import { render } from "./DeleteContactModal.vue?vue&type=template&id=7536a7dd&scoped=true"
import script from "./DeleteContactModal.vue?vue&type=script&lang=js"
export * from "./DeleteContactModal.vue?vue&type=script&lang=js"

import "./DeleteContactModal.vue?vue&type=style&index=0&id=7536a7dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7536a7dd"]])

export default __exports__